import { css } from '@emotion/css';
import colors from '@/theme/colors';
import {
  TitleLargeEmphasized,
  BodyLarge,
  ButtonPrimaryLarge,
} from '@/design-system';

type Props = {
  resendMagicLinkHandler: () => void;
};

const MagicLinkExpired = ({ resendMagicLinkHandler }: Props) => (
  <div className={styles.container}>
    <TitleLargeEmphasized as='h1'>Uh Oh!</TitleLargeEmphasized>
    <p className={styles.emailConfirmation}>
      <BodyLarge>
        The magic log in link you are trying to use is expired. Use the button
        below to receive a new one.
      </BodyLarge>
    </p>
    <div className={styles.ctaSection}>
      <ButtonPrimaryLarge onClick={resendMagicLinkHandler}>
        Resend Link
      </ButtonPrimaryLarge>
    </div>
  </div>
);

const styles = {
  container: css`
    padding: 0px 16px;
  `,
  emailConfirmation: css`
    color: ${colors.prussian};
    padding-top: 36px;
  `,
  ctaSection: css`
    margin-top: 40px;
  `,
  ctaSectionOptions: css`
    text-align: right;
  `,
};

export default MagicLinkExpired;
